<template>
  <section class="cardBox">
    <el-card :body-style="{ padding: '0px' }" shadow="hover">
      <div v-if="showHeader" slot="header">
        <slot name="header" />
      </div>
      <div v-if="direction == 'row'" class="cardBox-row">
        <section v-if="isImg" class="imgBox">
          <img
            :src="obj.cover_pic"
            :style="{ height: imgHeight,width:imgWidth?imgWidth:'%100' }"
            @click="handleRoute(obj)"
          >
        </section>
        <com-video
          v-else
          :obj="obj"
          :poster="obj.cover_pic"
          :img-height="imgHeight"
          @path="handleRoute"
        />
        <div>
          <span>
            <slot name="name" :style="{ width: basicWidth }" :obj="obj">{{
              obj.name
            }}</slot>
          </span>
          <span v-if="showControl">
            <slot name="control" :obj="obj">
              <span v-if="obj.is_collection == 0">
                <el-button v-if="obj.design_id" @click="jumpDetails(obj)">标准建设</el-button>
                <el-button
                  @click="handleControl(obj)"
                >收藏</el-button
                >
              </span>

              <span v-else>
                <el-button v-if="obj.design_id" @click="jumpDetails(obj)">标准建设</el-button>
                <el-button @click="handleControl(obj)">取消</el-button>
                <el-button v-if="isEdit" @click="handleControl1(obj)">编辑</el-button>

              </span>
            </slot>
          </span>
        </div>
      </div>
    </el-card>
  </section>
</template>

<script>
import comVideo from '@/components/system/comVideo'
export default {
  name: 'ComCard2',
  components: { comVideo },
  props: {
    isImg: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    showControl: {
      type: Boolean,
      default: true
    },
    imgHeight: {
      type: String,
      default: 'auto'
    },
    imgWidth: {
      type: String,
      default: null
    },
    direction: {
      type: String,
      default: 'row' // 主轴方向 row||column
    },
    basicWidth: {
      type: String,
      default: '270px'
    },
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    autoplay: {
      type: String,
      default: 'false' // false|true|muted
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleRoute(v) {
      this.$emit('path', v)
    },
    handleControl(v) {
      this.$emit('control', v)
    },
    handleControl1(v) {
      this.$emit('control1', v)
    },
    jumpDetails(obj) {
      this.$router.push({
        path: '/square/details',
        query: {
          id: obj.design_id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cardBox {
  width: 100%;
  &-row {
    // display: flex;
    // flex-direction: column;
    .imgBox{
      width: 100%;
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
    // > img {
    //   width: 100%;
    //   cursor: pointer;
    // }
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 66px;

      font-size: 14px;
      > span {
        &:nth-child(1) {
          cursor: pointer;
        }
        &:nth-child(2) {
          display: flex;
          > button {
            height: 30px;
            margin-left: 10px;
            padding: 0 20px;
            line-height: 30px;
            font-size: 12px;
          }
          > span {
            display: flex;
            > button {
              height: 30px;
              margin-left: 10px;
              padding: 0 20px;
              line-height: 30px;
              font-size: 12px;
            }
          }
        }
      }
    }
    >div:nth-child(2){
        padding: 10px 20px;
    }
  }
  &-column {
    display: flex;
    > img {
      height: 100%;
      width: 100%;
      cursor: pointer;
    }
    > span {
      flex: 1;
      height: 100%;
    }
  }
}
</style>
